<template>
    <TopNav></TopNav>
		<h1>BMI Calculator</h1>
		<fieldset>
      <legend>BMI Calculator</legend>
			<label for="kilogram">Weight:</label> <input type="number" v-model.number="inputKilogram" id="kilogram" step="any" min="0"> <abbr title="kilograms">㎏</abbr>
			<br>
			<label for="centimeters">Height:</label> <input type="number" v-model.number="inputCentimeter" id="centimeters" step="any" min="0"> <abbr title="centimeters">㎝</abbr>
      <br>
      BMI: <span class="blue">{{ bmi }} ㎏/㎡</span> <span v-bind:style="{color: currentState.color}">{{ currentState.text }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: 'Bmi',
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1
      }),
      inputCentimeter: 0,
      inputKilogram: 0
    }
  },
  components: {
    TopNav
  },
  computed: {
    bmi: function () {
      let bmi = this.inputKilogram / Math.pow((this.inputCentimeter / 100), 2);
      return this.formatter.format(bmi);
    },
    currentState: function () {
      if (this.bmi < 16) {
        return {"text": "Severe thinness", "color": "red"};
      } else if (this.bmi < 17) {
        return {"text": "Moderate thinness", "color": "red"};
      } else if (this.bmi < 18.5) {
        return {"text": "Mild thinness", "color": "orange"};
      } else if (this.bmi < 25) {
        return {"text": "Normal range", "color": "green"};
      } else if (this.bmi < 30) {
        return {"text": "Pre-obese", "color": "orange"};
      } else if (this.bmi < 35) {
        return {"text": "Obese class Ⅰ", "color": "red"};
      } else if (this.bmi < 40) {
        return {"text": "Obese class Ⅱ", "color": "red"};
      } else if (this.bmi >= 40) {
        return {"text": "Obese class Ⅲ", "color": "red"};
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
